import { memo } from 'react';
import cn from 'classnames';
import { IContent } from 'src/interface';
import { Element, Icon } from 'src/components';
import LikeButton from 'src/modules/shared/components/buttons/LikeButton';
import ZaloShareButton from 'src/modules/shared/components/buttons/ZaloShareButton';
import FacebookButton from 'src/modules/shared/components/buttons/FacebookButton';
import styles from './style.module.scss';

interface IProps {
    content: IContent;
    url: string;
}

const ContentSocial = ({ content, url }: IProps) => {
    if (!content) {
        return null;
    }
    return (
        <Element className={cn(styles['content-social'])}>
            <LikeButton
                content={content}
                className={styles['btn-social']}
                text="Like"
            />
            <ZaloShareButton
                className={cn(
                    styles['btn-social'],
                    'btn-zalo',
                    'items-center',
                    'p-[0.5rem]',
                    'rounded-[3px]',
                    'h-[40px]',
                    'bg-[#03a5fa]',
                )}
                link={url}
                title={content.title}
            >
                <Icon type="bm" icon="zalo"></Icon>
                <Element
                    renderAs="span"
                    className={cn(
                        'text-[1.4rem] text-white',
                        'pl-[15px] ml-[5px]',
                        'relative',
                        'before:w-[1px] before:h-[18px]',
                        'before:absolute before:left-0 before:top-[1px]',
                        'before:bg-[rgba(255,255,255,0.5)]'
                    )}
                >
                    Zalo
                </Element>
            </ZaloShareButton>
            <FacebookButton
                className={cn(styles['btn-social'], styles['btn-facebook'])}
                link={url}
                title={content.title}
            >
                <Icon type="bm" icon="facebook" />
                <Element renderAs="span">Facebook</Element>
            </FacebookButton>
        </Element>
    );
};

export default memo(ContentSocial);
